module.exports = __webpack_public_path__ + "static/media/CERTIFICATE-LIGA-ANAK-PINTAR-3.34a1b1ee.png";